import { ROLES as R } from "../core/roles";
import { lud, rule } from "../core/rule";
import { SCOPES } from "../core/scope";

const restaurantScoped = (roles) => rule(roles, { scope: SCOPES.RESTAURANT });

export const reportPermissions = {
  view: "report.view",
  approve: "report.approve",
  bulkDelete: "report.bulkDelete",
  monthly: {branchOpen: "report.monthly.branch.open" },
  entry: { update: "report.entry.update", delete: "report.entry.delete" },
};

export const reportGrants = {
  "report.view": rule(lud(R.FA, R.DM, R.DMM, R.AM, R.SALES, R.STORE_L, R.STORE, R.NEW)),
  // approve a month / app / branch in the daily and details reports
  "report.approve": restaurantScoped(lud(R.DM, R.DMM, R.FA)),
  // delete everything matching the current filter
  "report.bulkDelete": rule(lud(R.DMM)),
  "report.monthly.branch.open": rule(lud(R.DMM, R.FA)),
  "report.entry.update": restaurantScoped(lud(R.DMM)),
  "report.entry.delete": restaurantScoped(lud(R.DMM)),
};
